<template>
  <div id="app">
    <!-- Header content-->
    <Navbar />
    <!--Body content -->
    <main role="main" class="flex-shrink-0">
      <router-view />
    </main>
    <!--Footer content -->
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";

import Navbar from "@/components/Navbar.vue";

export default {
  name: "App",
  metaInfo: {
    title: "Home Page",
    titleTemplate: "Finult Advisors - %s",
    meta: [
      { charset: "utf-8" },
      {
        property: "Home Page",
        content:
          "Finult Advisory Private Limited, Located in Bangalore, JP Nagar as their Coporate branch",
        vmid: "Home Page"
      }
    ]
  },
  components: {
    Footer,
    Navbar
  },
  data() {
    return {};
  }
};
</script>
<style></style>
